import type { CompanyAnalytics } from "@/modules/companies/client/api/types"

import { useQuery } from "@tanstack/react-query"
import { useParams } from "next/navigation"

import {
  COMPANY_ARTICLE_ANALYTICS_QUERY_KEY,
  getCompanyAnalytics,
} from "@/modules/companies/client/api/endpoints/companyAnalytics"
import { QUERY_CACHE_TIME, QUERY_STALE_TIME } from "@/modules/companies/client/constants/enums"
import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"

type CompanyAnalyticsFetch = {
  dataCompanyAnalytics?: CompanyAnalytics
  isLoadingCompanyAnalytics: boolean
  isSuccessCompanyAnalytics: boolean
  isErrorCompanyAnalytics: boolean
}

export const useCompanyAnalyticsFetch = (): CompanyAnalyticsFetch => {
  const { dataCompany } = useCompanyFetch()
  const { companySlug } = useParams()

  const {
    data: dataCompanyAnalytics,
    isPending: isLoadingCompanyAnalytics,
    isSuccess: isSuccessCompanyAnalytics,
    isError: isErrorCompanyAnalytics,
  } = useQuery({
    enabled: !!dataCompany?.id,
    gcTime: QUERY_CACHE_TIME,
    queryFn: () =>
      getCompanyAnalytics({
        permalink: companySlug as string,
      }),
    queryKey: [COMPANY_ARTICLE_ANALYTICS_QUERY_KEY, companySlug],
    staleTime: QUERY_STALE_TIME,
  })

  return {
    dataCompanyAnalytics,
    isErrorCompanyAnalytics,
    isLoadingCompanyAnalytics,
    isSuccessCompanyAnalytics,
  }
}
